export default __webpack_public_path__ + "static/media/btn-zeroback-start-es_es@2x.0a230ad6.png";